'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterList = exports.showModal = exports.getApplicantDetailFields = exports.getBaseFields = exports.showDeductible = exports.showStateProvinceOfResidence = exports.showDestinationProvince = exports.showCountryOfOrigin = exports.showSuperVisa = exports.showInCanadaHint = exports.applicationCoverageOptions = exports.policyTypeField = exports.expiryDateField = exports.showSaveQuoteComponent = exports.showCancelDelux = exports.showTripCost = exports.showEligibilityBox = exports.effectiveDateField = exports.showCoverageLength = exports.showSchoolField = exports.showStudentNumberField = exports.staticCoverageTypeField = exports.coverageTypeField = exports.showErrorDiv = exports.checkApplicantMaxAge = exports.createAdditionalApplicantRows = exports.showPrimaryApplicantInfo = exports.showSectionHeader = exports.populateQuoteData = exports.submitFormDetails = exports.sendSavedQuoteEmail = exports.saveQuoteNum = exports.updateQuote = exports.getDefaultCoverage = exports.mountStripe = exports.handleSubmitForm = exports.loadForm = exports.progressBarText = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mountForm = mountForm;
exports.associatedForm = associatedForm;
exports.checkSuperVisa = checkSuperVisa;
exports.strToFloat = strToFloat;
exports.getVal = getVal;
exports.isMultiTrip = isMultiTrip;
exports.isSingleTrip = isSingleTrip;
exports.destinationCA_US = destinationCA_US;
exports.renewalForm = renewalForm;
exports.getFormCoverage = getFormCoverage;
exports.getFormTypeTitle = getFormTypeTitle;
exports.getFormTitle = getFormTitle;
exports.getContainerProps = getContainerProps;
exports.rimiVTCProducts = rimiVTCProducts;
exports.fillQuestion = fillQuestion;
exports.populateEligibility = populateEligibility;
exports.showErrors = showErrors;
exports.changeExpiryAndCoverageLength = changeExpiryAndCoverageLength;
exports.getSchoolCode = getSchoolCode;
exports.getTrackingPartner = getTrackingPartner;
exports.getCountryStatesProvinces = getCountryStatesProvinces;
exports.transformApplication = transformApplication;
exports.setValueFromParam = setValueFromParam;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = require('react-bootstrap');

var _dateFunctions = require('../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

var _ActionCreators = require('../actions/ActionCreators');

var _translate = require('../language/translate');

var _ApplicantComponent = require('../components/common/ApplicantComponent.jsx');

var _ApplicantComponent2 = _interopRequireDefault(_ApplicantComponent);

var _NewErrorDivComponent = require('../components/common/NewErrorDivComponent');

var _NewErrorDivComponent2 = _interopRequireDefault(_NewErrorDivComponent);

var _SaveQuoteComponent = require('../components/common/SaveQuoteComponent');

var _SaveQuoteComponent2 = _interopRequireDefault(_SaveQuoteComponent);

var _HiderComponent = require('../components/common/HiderComponent');

var _HiderComponent2 = _interopRequireDefault(_HiderComponent);

var _SectionHeaderComponent = require('../components/common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _TextInputComponent = require('../components/input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _SelectComponent = require('../components/input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _LabelledInputComponent = require('../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _CheckboxComponent = require('../components/input/CheckboxComponent');

var _CheckboxComponent2 = _interopRequireDefault(_CheckboxComponent);

var _DatePickerComponent = require('../components/input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _FullWidthInputComponent = require('../components/input/FullWidthInputComponent');

var _FullWidthInputComponent2 = _interopRequireDefault(_FullWidthInputComponent);

var _CurrencyInputComponent = require('../components/input/CurrencyInputComponent');

var _CurrencyInputComponent2 = _interopRequireDefault(_CurrencyInputComponent);

var _RadioGroupComponent = require('../components/input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _ExpandableHintComponent = require('../components/input/ExpandableHintComponent');

var _ExpandableHintComponent2 = _interopRequireDefault(_ExpandableHintComponent);

var _url = require('../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function mountForm(context) {
  var _this = this;

  (0, _translate.setLocale)(context.props.params.language);

  return new Promise(function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
      var auth;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return context.props.getAuth(context.source, context.props.params.language);

            case 2:
              auth = _context.sent;

              context.props.getFormConfig(context.source, context.props.params.language, auth.payload.data);

              if (context.props.location.query.reference_id) {
                context.props.getSavedQuote(context.source, context.props.params.language, auth.payload.data, context.props.location.query.reference_id);
              } else if (context.props.location.query.renewal_id) {
                context.props.getRenewal(context.source, context.props.params.language, auth.payload.data, context.props.location.query.renewal_id);
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

var progressBarText = exports.progressBarText = function progressBarText() {
  return {
    progressText: [{
      description: (0, _translate.t)('Get Quote')
    }, {
      description: (0, _translate.t)('Complete Application')
    }, {
      description: (0, _translate.t)('Confirmation')
    }]
  };
};

function headerProps(context) {
  var brand = context.props.formConfig.config.brand;
  // const lang = context.props.params.language;
  return {
    coverageSummary: context.props.formConfig.config.coverage_summary || null,
    logos: [{
      src: 'https://s3.ca-central-1.amazonaws.com/msh-assets/insurance/' + brand + '_' + (0, _translate.t)('en') + '.png',
      alt: (0, _translate.t)('MSH International') + '\u2122'
    }],
    progressBarProps: progressBarText()
  };
}

function associatedForm() {
  return (0, _url2.default)('form_type') === 'associated';
}

function checkSuperVisa(context) {
  var yesno = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yes';

  return context.props.fields.application.additional_data.super_visa.value === yesno;
}

function strToFloat(val) {
  return parseFloat(val === undefined ? 0 : String(val).replace(',', ''));
}

function getVal(obj) {
  return obj ? obj.value === undefined ? obj : obj.value : null;
}

function isMultiTrip(values) {
  return getVal(values.application.additional_data.policy_type) === 'multi-trip annual';
}

function isSingleTrip(values) {
  return getVal(values.application.additional_data.policy_type) === 'single trip';
}

function destinationCA_US(values) {
  return ['US', 'CA'].includes(getVal(values.application.additional_data.destination));
}

function renewalForm() {
  return (0, _url2.default)('form_type') === 'renewal';
}

function getFormCoverage() {
  var coverage = (0, _url2.default)('coverage');
  return coverage && (0, _translate.t)(coverage) || '';
}

function getFormTypeTitle() {
  if (renewalForm()) {
    return (0, _translate.t)('Policy Extension Application');
  }

  if (associatedForm()) {
    return (0, _translate.t)('Associated');
  }

  return '';
}

function getFormTitle(productName) {
  return getFormCoverage() + ' ' + productName + ' ' + getFormTypeTitle();
}

var capitalize = function capitalize(s) {
  return s && s[0].toUpperCase() + s.slice(1);
};

var loadForm = exports.loadForm = function loadForm(context) {
  context.sourceName = context.props.formConfig.config.full_name;
  document.title = capitalize(getFormTitle(context.sourceName));
  return !(context.props.location.query.renewal_id || context.props.location.query.reference_id) || context.props.savedQuoteLoaded;
};

function getContainerProps(context) {
  return {
    headerTitle: getFormTitle(context.sourceName),
    headerProps: headerProps(context)
  };
}

function isRecurringPaymentEnabled(fields) {
  return fields.payment.payment_option.value === 'monthly';
}

function rimiVTCProducts(sourceName) {
  return ['visitcanadavisitors', 'insurecanadavisitor', 'rimivisitorstocanada'].includes(sourceName);
}
/**
 * Formats input value to a currency value.
 * @param value
 * @param symbol
 * @param precision
 * @param thousandSeparator
 * @param decimalSeparator
 * @returns String currency value.
 */
var handleSubmitForm = exports.handleSubmitForm = function handleSubmitForm(values, dispatch, context, applicant) {
  return new Promise(function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var errors, paymentProvider, paymentMethodType, firstPayment, payment_option, isSplitPayment, form, creditCardHolderName, _ref3, paymentMethod, error;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              errors = [];

              if (context.props.application.payment.paid) {
                _context2.next = 5;
                break;
              }

              _context2.next = 4;
              return dispatch((0, _ActionCreators.createApplicant)(context.props.formName, context.props.params.language, context.props.auth, context.props.application.id, applicant(values)));

            case 4:

              if (!context.props.application.applicants.created) {
                if (context.props.application.applicants.error) {
                  errors = errors.concat(context.props.application.applicants.error);
                } else {
                  errors.push({ message: (0, _translate.t)('Encountered an error while processing applicant data.') });
                }
              }

            case 5:
              paymentProvider = 'invoice';
              paymentMethodType = null;
              firstPayment = context.props.fields.payment.amount.value;
              payment_option = isRecurringPaymentEnabled(context.props.fields) ? context.props.fields.payment.payment_option.value : 'lumpsum';
              isSplitPayment = rimiVTCProducts(context.props.formName) && payment_option !== 'monthly';

              if ((0, _url2.default)('user_code', null)) {
                _context2.next = 25;
                break;
              }

              form = document.getElementById('payment-form');
              creditCardHolderName = document.getElementById('creditCardHolderName').value;
              _context2.next = 15;
              return context.stripe.createPaymentMethod({
                type: 'card',
                card: context.card,
                billing_details: {
                  name: creditCardHolderName
                }
              });

            case 15:
              _ref3 = _context2.sent;
              paymentMethod = _ref3.paymentMethod;
              error = _ref3.error;


              if (creditCardHolderName.length === 0) {
                errors.push({ message: (0, _translate.t)('The cardholder name is incomplete') });
              }

              if (error !== undefined && error.code.length > 0) {
                errors.push({ message: error.message });
              }

              if (!(errors.length > 0)) {
                _context2.next = 23;
                break;
              }

              reject({ _error: errors });
              return _context2.abrupt('return');

            case 23:

              paymentProvider = 'stripe';
              paymentMethodType = paymentMethod.id;

            case 25:
              if (context.props.application.confirmation.confirmed) {
                _context2.next = 40;
                break;
              }

              _context2.next = 28;
              return dispatch((0, _ActionCreators.makeApplicationPayment)(context.props.formName, context.props.params.language, context.props.auth, context.props.application.id, {
                payment_provider: paymentProvider,
                application_id: context.props.application.id,
                amount: context.props.fields.payment.amount.value,
                currency: 'cad',
                additional_data: {
                  payment_method: paymentMethodType,
                  payment_option: payment_option
                }
              }));

            case 28:
              if (!context.props.application.payment.error) {
                _context2.next = 31;
                break;
              }

              reject({ _error: errors.concat(context.props.application.payment.error) });
              return _context2.abrupt('return');

            case 31:

              if (isSplitPayment) {
                errors.push({ message: 'success' });
                errors.push({ message: 'First payment of $' + firstPayment + ' CAD was successful.' });
                context.updateProp('msgType', 'success');
                context.updateProp('payment.amount', context.props.application.payment.pending);
                context.updateProp('payment.pending', context.props.application.payment.pending);
                reject({ _error: errors });
              }

              if (!(!isSplitPayment || strToFloat(context.props.application.payment.pending) === 0)) {
                _context2.next = 40;
                break;
              }

              _context2.next = 35;
              return dispatch((0, _ActionCreators.getApplicationConfirmation)(context.props.formName, context.props.params.language, context.props.auth, context.props.application.id));

            case 35:
              if (context.props.application.confirmation.confirmed) {
                _context2.next = 39;
                break;
              }

              if (context.props.application.payment.error) {
                errors = errors.concat(context.props.application.payment.error);
              } else if (context.props.application.confirmation.error) {
                errors = errors.concat(context.props.application.confirmation.error);
              } else {
                errors.push({ message: (0, _translate.t)('Encountered an error while processing applicant data.') });
              }
              reject({ _error: errors });
              return _context2.abrupt('return');

            case 39:
              context.props.forward();

            case 40:
              resolve();

            case 41:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }());
};

var mountStripe = exports.mountStripe = function mountStripe(context, stripeAccount) {
  if ((0, _url2.default)('user_code', null)) return;

  var style = {
    base: {
      iconColor: '#337ab7',
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#337ab7'
      },
      '::placeholder': {
        color: '#337ab7'
      }
    },
    invalid: {
      iconColor: '#FFC7EE',
      color: '#FFC7EE'
    }
  };

  context.stripe = Stripe(_config2.default.stripe_keys[stripeAccount]);
  var elements = context.stripe.elements();
  context.card = elements.create('card', { style: style });
  context.card.mount('#card-element');
};

var getDefaultCoverage = exports.getDefaultCoverage = function getDefaultCoverage(context) {
  var effDateValue = context.props.fields.application.effective_date.value;
  var expDateValue = context.props.fields.application.expiry_date.value;
  var coverageLength = void 0;

  if (!(context.disableExpiryDate && context.disableExpiryDate()) && effDateValue && expDateValue) {
    coverageLength = '' + ((0, _moment2.default)(expDateValue).diff((0, _moment2.default)(effDateValue), 'days') + 1);
  }

  return coverageLength;
};

var updateQuote = exports.updateQuote = function updateQuote(context, applicationTransformer) {
  var coverageLength = context.props.fields.application.additional_data.coverage_length;
  context.reqCount = context.reqCount === undefined ? 1 : ++context.reqCount;
  context.props.dispatch((0, _ActionCreators.updateLiveQuote)(context, applicationTransformer(context.formConfig, context.props.values, context.props.trackingCode, context.props.params.coverageType)));

  if (context.disableExpiryDate && context.disableExpiryDate() && context.props.fields.application.effective_date.value) {
    var coverageLengthValue = 365 + _dateFunctions2.default.getLeapYearDay(context.props.fields.application.effective_date.value, 364);
    coverageLength.onChange(coverageLengthValue.toString());
  } else if (context.props.fields.application.effective_date.value && context.props.fields.application.expiry_date.value) {
    coverageLength.onChange(getDefaultCoverage(context));
  } else {
    coverageLength.onChange('');
  }

  context.props.application.id = null;
  context.setState({
    showSaveQuote: true
  });
};

var saveQuoteNum = exports.saveQuoteNum = function saveQuoteNum(context) {
  context.setState({
    loadingModalText: (0, _translate.t)('Fetching Quote')
  });

  context.props.dispatch((0, _ActionCreators.returnQuoteNumber)(context.props.formName, context.props.params.language, context.props.auth, context.props.application.id));
};

var sendSavedQuoteEmail = exports.sendSavedQuoteEmail = function sendSavedQuoteEmail(context, emails) {
  context.setState({
    loadingModalText: (0, _translate.t)('Emailing Quote')
  });

  context.props.dispatch((0, _ActionCreators.returnEmailSavedQuote)(context.props.formName, context.props.params.language, context.props.auth, context.props.application.id, emails));
};

var submitFormDetails = exports.submitFormDetails = function submitFormDetails(context, data) {
  var formName = context.props.children[0].props.formName;
  var lang = context.props.children[0].props.params.language;
  context.props.dispatch((0, _ActionCreators.submitContactForm)(formName, lang, context.props.auth, data));
};

function populateApplicantData(context, propPrefix, data) {
  context.updateProp(propPrefix + '.first_name', data.first_name);
  context.updateProp(propPrefix + '.last_name', data.last_name);
  context.updateProp(propPrefix + '.dob', data.dob);
  context.updateProp(propPrefix + '.email', data.email);
  context.updateProp(propPrefix + '.additional_data.pe_coverage', data.additional_data.pe_coverage);
  context.updateProp(propPrefix + '.additional_data.relationship_to_primary_applicant', data.additional_data.relationship_to_primary_applicant);
}

function fillQuestion(context, propPrefix, data, questionIndex) {
  context.updateProp(propPrefix + '.additional_data.mq.mq' + questionIndex, data[questionIndex - 1]);
}

function populateBasicApplicationData(context, data) {
  context.updateProp('application.effective_date', data.effective_date);
  context.updateProp('application.expiry_date', data.expiry_date);
  context.updateProp('application.created_at', data.created_at);
  context.updateProp('application.additional_data.quote_reference_id', data.reference_id);
  context.updateProp('application.additional_data.coverage_length', data.additional_data.coverage_length);
  context.updateProp('application.additional_data.additional_applicants_number', data.additional_data.additional_applicants_number || data.applicants.length - 1);
  context.updateProp('payment.payment_option', data.additional_data.payment_option);

  if (data.additional_data.school) {
    context.updateProp('application.additional_data.school', data.additional_data.school);
  }
}

function changeApplicantAmount(context) {
  var displayedApplicants = context.props.fields.applicant ? Math.max(context.props.fields.applicant.length, 1) : 1;
  var difference = displayedApplicants - context.props.fields.application.additional_data.additional_applicants_number.value;

  if (difference > 0) {
    for (var i = 1; i < difference; i++) {
      context.props.fields.applicant.removeField();
    }
  } else {
    for (var _i = 1; _i > difference; _i--) {
      context.props.fields.applicant.addField();
    }
  }
}

function populateRenewalData(context, data) {
  if ((0, _url2.default)('renewal_id')) {
    for (var i = 0; i < data.applicants.length; i++) {
      populateApplicantData(context, 'applicant[' + i + ']', data.applicants[i]);
    }

    context.updateProp('application.effective_date', null);
    context.updateProp('application.expiry_date', null);

    if (data.additional_data && data.additional_data.school) {
      context.updateProp('application.additional_data.school', data.additional_data.school);
    }
  }
}

function populateEligibility(context, data) {
  if ((0, _url2.default)('form') === 'read_only') {
    context.updateProp('application.additional_data.eligibility', data.additional_data.eligibility);
    context.setState({ quotePriceFetched: true }, function () {
      context.onChangeHook();
    });
  }
}

var populateQuoteData = exports.populateQuoteData = function populateQuoteData(context, populateProductSpecificData) {
  if (context.props.toggleFetcheDataPopulated(0) && context.props.savedQuote && !context.props.application.id) {
    var data = context.props.savedQuote;
    context.props.fields.application.additional_data.additional_applicants_number.value = data.additional_data.additional_applicants_number;
    populateBasicApplicationData(context, data);
    changeApplicantAmount(context);

    if ((0, _url2.default)('reference_id')) {
      for (var i = 0; i < data.additional_data.additional_applicants_number + 1; i++) {
        populateApplicantData(context, 'applicant[' + i + ']', data.additional_data.applicants[i]);
      }
    }

    populateProductSpecificData(context, data);
    populateRenewalData(context, data);
  }
};

var showSectionHeader = exports.showSectionHeader = function showSectionHeader(header) {
  return _react2.default.createElement(
    _SectionHeaderComponent2.default,
    null,
    header
  );
};

function makeApplicant(i, context, dates) {
  return _react2.default.createElement(_ApplicantComponent2.default, {
    formValues: context.props.values,
    dates: dates,
    onChangeHook: context.onChangeHook,
    key: i,
    dynamicFieldIndex: i - 1,
    inputComponentField: context.props.fields.applicant[i],
    relationshipOptions: i === 0 ? false : context.formConfig['additional_data.relationship_to_primary_applicant'].options,
    showNames: context.state.showNames,
    showSchoolDropdown: context.props.eachApplicantHasSchool,
    formConfig: context.formConfig,
    peCoverage: context.props.hasPeCoverage
  });
}

var showPrimaryApplicantInfo = exports.showPrimaryApplicantInfo = function showPrimaryApplicantInfo(context, dates) {
  var i = 0;
  return context.props.fields.applicant.length === 0 ? null : _react2.default.createElement(
    'div',
    null,
    showSectionHeader(context.formConfig.applicant_section_header.title),
    makeApplicant(i, context, dates),
    context.props.applicationHasSchool && _react2.default.createElement(_LabelledInputComponent2.default, {
      hasExpandableHint: Boolean(context.formConfig['additional_data.school'].hint),
      expandableHintId: 'schoolNameHint',
      expandableHintTitle: context.formConfig['additional_data.school'].label,
      expandableHintContent: context.formConfig['additional_data.school'].hint,
      inputId: 'schoolName',
      inputLabel: context.formConfig['additional_data.school'].title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.application.additional_data.school,
      inputComponentProps: {
        type: 'text',
        onChangeHook: context.onChangeHook
      }
    }),
    context.props.hasStudentId && _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'studentId',
      inputLabel: context.formConfig['additional_data.student_number'].title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.student_number,
      inputComponentProps: {
        type: 'text',
        onChangeHook: context.onChangeHook
      }
    })
  );
};

var createAdditionalApplicantRows = exports.createAdditionalApplicantRows = function createAdditionalApplicantRows(context, dates) {
  var rows = [];
  for (var i = 1; i < context.props.fields.applicant.length; i++) {
    rows.push(makeApplicant(i, context, dates));
  }
  return _react2.default.createElement(
    'div',
    { className: 'additional-applicants' },
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'additional_applicants',
      inputLabel: context.formConfig['additional_data.additional_applicants_number'].title,
      inputComponent: _SelectComponent2.default,
      inputComponentField: context.props.fields.application.additional_data.additional_applicants_number,
      inputComponentProps: {
        options: context.formConfig['additional_data.additional_applicants_number'].options,
        placeholder: (0, _translate.t)('Please select...'),
        onChangeHook: function onChangeHook() {
          changeApplicantAmount(context);context.onChangeHook();
        }
      }
    }),
    rows
  );
};

var checkApplicantMaxAge = exports.checkApplicantMaxAge = function checkApplicantMaxAge(context, maxAge) {
  var allApplicants = context.props.fields.applicant;

  for (var i = 0; i < allApplicants.length; i++) {
    var dob = allApplicants[i].dob.value;
    var effDate = (0, _moment2.default)(context.props.fields.application.effective_date.value);

    if (_moment2.default.duration(effDate.diff(dob)).asYears() >= maxAge) {
      return true;
    }
  }
  return false;
};

var showErrorDiv = exports.showErrorDiv = function showErrorDiv(context) {
  return _react2.default.createElement(_NewErrorDivComponent2.default, {
    errors: context.props.application.quote.information,
    fields: context.props.fields,
    showErrors: context.state.showErrors
  });
};

function removeForm() {
  var url = window.location.href.replace('read_only', 'editable');
  if (window.location.href.includes('form')) {
    _reactRouter.browserHistory.push(url);
  }
}

function showErrors(context, application) {
  updateQuote(context, application);
  context.setState({ showErrors: true });
  removeForm();
}

var coverageTypeField = exports.coverageTypeField = function coverageTypeField(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'coverageTypeHint',
    expandableHintContent: context.formConfig['additional_data.coverage_type'].hint,
    expandableHintTitle: context.formConfig['additional_data.coverage_type'].title,
    inputId: 'coverageType',
    inputLabel: context.formConfig['additional_data.coverage_type'].title,
    inputComponent: _SelectComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.coverage_type,
    inputComponentProps: {
      options: context.formConfig['additional_data.coverage_type'].options,
      onChangeHook: context.onChangeHook
    }
  });
};

var staticCoverageTypeField = exports.staticCoverageTypeField = function staticCoverageTypeField(context) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'coverageType',
      inputLabel: context.formConfig['additional_data.coverage_type'].title,
      inputComponent: _reactBootstrap.FormControl.Static,
      inputComponentChildren: context.props.fields.application.additional_data.coverage_type.value.toUpperCase(),
      isStatic: true
    }),
    coverageTypeField(context)
  );
};

var showStudentNumberField = exports.showStudentNumberField = function showStudentNumberField(context) {
  var i = 0;
  return context.props.fields.applicant.length === 0 ? null : _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'studentId',
    inputLabel: 'Student ID Number',
    inputComponent: _TextInputComponent2.default,
    inputComponentField: context.props.fields.applicant[i].additional_data.student_number,
    inputComponentProps: {
      type: 'text',
      onChangeHook: context.onChangeHook
    }
  });
};

var showSchoolField = exports.showSchoolField = function showSchoolField(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'schoolId',
    inputLabel: (0, _translate.t)('Name of School'),
    inputComponent: _TextInputComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.school,
    inputComponentProps: {
      type: 'text',
      onChangeHook: context.onChangeHook
    }
  });
};

function getDestinationProvince(provinces) {
  // Remove Quebec from the options of Destination Province for agents RIMI004
  if (['RIMI004', '2VISIT002'].includes((0, _url2.default)('tracking_code'))) {
    return provinces.filter(function (province) {
      return province.value !== 'QC';
    });
  }
  return provinces;
}

function changeExpiryAndCoverageLength(context, field) {
  var coverageLength = context.props.fields.application.additional_data.coverage_length;

  if (field === 'coverage') {
    var defaultExpiryDate = void 0;

    if (coverageLength.value <= '1') {
      defaultExpiryDate = '';
    } else if (!(context.disableExpiryDate && context.disableExpiryDate()) && context.getMaxCoverageLength && context.getMaxCoverageLength()) {
      defaultExpiryDate = (0, _moment2.default)(context.props.fields.application.effective_date.value).add(context.ageLimits.maxCoverageLength, 'days').subtract({ days: 1 }).format('YYYY-MM-DD');
    } else {
      defaultExpiryDate = (0, _moment2.default)(context.props.fields.application.effective_date.value).add(coverageLength.value, 'days').subtract({ days: 1 }).format('YYYY-MM-DD');
    }

    context.props.fields.application.expiry_date.onChange(defaultExpiryDate);
  } else {
    coverageLength.onChange(getDefaultCoverage(context));
  }
}

var showCoverageLength = exports.showCoverageLength = function showCoverageLength(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'coverageLength',
    inputLabel: (0, _translate.t)('Coverage Length'),
    inputComponent: _TextInputComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.coverage_length,
    inputComponentProps: {
      type: 'num',
      onChangeHook: function onChangeHook() {
        changeExpiryAndCoverageLength(context, 'coverage');context.onChangeHook();
      },
      disabled: context.disableExpiryDate && context.disableExpiryDate() || !context.props.fields.application.effective_date.value
    }
  });
};

var effectiveDateField = exports.effectiveDateField = function effectiveDateField(context, dates) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'effectiveDate',
    inputLabel: context.formConfig.effective_date.title,
    inputComponent: _DatePickerComponent2.default,
    inputComponentField: context.props.fields.application.effective_date,
    inputComponentProps: {
      placeholderText: (0, _translate.t)('Please select a date...'),
      showYearDropdown: true,
      showMonthDropdown: true,
      onChangeHook: function onChangeHook() {
        changeExpiryAndCoverageLength(context, 'effective');context.onChangeHook();
      },
      minDate: dates.application.effective_date.min,
      maxDate: dates.application.effective_date.max
    }
  });
};

var showEligibilityBox = exports.showEligibilityBox = function showEligibilityBox(context) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_FullWidthInputComponent2.default, {
      hasExpandableHint: true,
      expandableHintId: 'applicantElibigilityHint',
      expandableHintTitle: context.formConfig['additional_data.eligibility'].title,
      expandableHintContent: context.formConfig['additional_data.eligibility'].hint,
      inputId: 'applicantEligibility',
      inputLabel: context.formConfig['additional_data.eligibility'].label,
      inputComponent: _CheckboxComponent2.default,
      inputComponentField: context.props.fields.application.additional_data.eligibility,
      inputComponentProps: {
        onChangeHook: context.onChangeHook,
        disabled: (0, _url2.default)('form') === 'read_only'
      }
    }),
    showSectionHeader(context.formConfig.coverage_section_header.title)
  );
};

var showTripCost = exports.showTripCost = function showTripCost(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'tripcost',
    expandableHintTitle: context.formConfig.trip_cost.title,
    expandableHintContent: context.formConfig.trip_cost.hint,
    inputId: 'trip_cost',
    inputLabel: context.formConfig.trip_cost.title,
    inputComponent: _CurrencyInputComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.trip_cost,
    inputComponentProps: {
      onChangeHook: context.onChangeHook
    }
  });
};

var showCancelDelux = exports.showCancelDelux = function showCancelDelux(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'canceldelux',
    expandableHintTitle: context.formConfig['additional_data.cancel_delux'].title,
    expandableHintContent: context.formConfig['additional_data.cancel_delux'].hint,
    inputId: 'cancel_delux',
    inputLabel: context.formConfig['additional_data.cancel_delux'].title,
    inputComponent: _SelectComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.cancel_delux,
    inputComponentProps: {
      options: context.formConfig['additional_data.cancel_delux'].options,
      onChangeHook: context.onChangeHook
    }
  });
};

var showSaveQuoteComponent = exports.showSaveQuoteComponent = function showSaveQuoteComponent(context, application) {
  return _react2.default.createElement(_SaveQuoteComponent2.default, _extends({}, context.props, {
    showSaveQuote: context.props.quoteEnabled && context.state.showSaveQuote,
    context: context,
    showErrors: showErrors.bind(context, context, application)
  }));
};

var expiryDateField = exports.expiryDateField = function expiryDateField(context, dates) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'expiryDate',
    inputLabel: context.formConfig.expiry_date.title,
    inputComponent: _DatePickerComponent2.default,
    inputComponentField: context.props.fields.application.expiry_date,
    inputComponentProps: {
      placeholderText: (0, _translate.t)('Please select a date...'),
      showYearDropdown: true,
      showMonthDropdown: true,
      onChangeHook: function onChangeHook() {
        changeExpiryAndCoverageLength(context, 'expiry');context.onChangeHook();
      },
      minDate: dates.application.expiry_date.min,
      maxDate: dates.application.expiry_date.max,
      defaultDate: context.hasDefaultExpiry && context.getExpiryDate(),
      disabled: context.disabledExpiryDate && context.disableExpiryDate()
    }
  });
};

var policyTypeField = exports.policyTypeField = function policyTypeField(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'applicationPolicyType',
    expandableHintTitle: context.formConfig['additional_data.policy_type'].title,
    expandableHintContent: context.formConfig['additional_data.policy_type'].hint,
    inputId: 'policyType',
    inputLabel: context.formConfig['additional_data.policy_type'].title,
    inputComponent: _SelectComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.policy_type,
    inputComponentProps: {
      options: context.formConfig['additional_data.policy_type'].options,
      onChangeHook: context.onChangeHook
    }
  });
};

var applicationCoverageOptions = exports.applicationCoverageOptions = function applicationCoverageOptions(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'applicationCoverageOptions',
    expandableHintTitle: context.formConfig['additional_data.coverage'].title,
    expandableHintContent: context.formConfig['additional_data.coverage'].hint,
    inputId: 'coverageOptions',
    inputLabel: context.formConfig['additional_data.coverage'].title,
    inputComponent: _SelectComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.coverage,
    inputComponentProps: {
      options: context.getCoverageOptions(context.formConfig['additional_data.coverage'].options),
      onChangeHook: context.onChangeHook
    }
  });
};

var showInCanadaHint = exports.showInCanadaHint = function showInCanadaHint(context) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'inCanada',
      inputLabel: context.formConfig['additional_data.in_canada'].title,
      inputComponent: _RadioGroupComponent2.default,
      inputComponentField: context.props.fields.application.additional_data.in_canada,
      inputComponentProps: {
        options: context.formConfig['additional_data.in_canada'].options,
        onChangeHook: context.onChangeHook
      }
    }),
    _react2.default.createElement(
      _HiderComponent2.default,
      { isHidden: context.props.fields.application.additional_data.in_canada.value !== 'yes' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ExpandableHintComponent2.default, {
          hintStatus: 'true',
          hintId: 'inCanadaYesInfp',
          hintTitle: context.formConfig['additional_data.in_canada_yes'].title,
          hintContent: context.formConfig['additional_data.in_canada_yes'].hint,
          isHintRawHtml: false
        })
      )
    )
  );
};

var showSuperVisa = exports.showSuperVisa = function showSuperVisa(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'applicationSuperVisa',
    expandableHintTitle: context.formConfig['additional_data.super_visa'].label,
    expandableHintContent: context.formConfig['additional_data.super_visa'].hint,
    inputId: 'superVisa',
    inputLabel: context.formConfig['additional_data.super_visa'].title,
    inputComponent: _RadioGroupComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.super_visa,
    inputComponentProps: {
      options: context.formConfig['additional_data.super_visa'].options,
      onChangeHook: context.onChangeHook
    }
  });
};

var showCountryOfOrigin = exports.showCountryOfOrigin = function showCountryOfOrigin(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'countryOfOrigin',
    expandableHintTitle: context.formConfig['additional_data.country_of_origin'].title,
    expandableHintContent: context.formConfig['additional_data.country_of_origin'].hint,
    inputId: 'countryOfOrigin',
    inputLabel: context.formConfig['additional_data.country_of_origin'].title,
    inputComponent: _SelectComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.country_of_origin,
    inputComponentProps: {
      options: context.formConfig['additional_data.country_of_origin'].options.filter(function (country) {
        return country.value !== context.props.removeHomeCountry;
      }),
      onChangeHook: context.onChangeHook
    }
  });
};

var showDestinationProvince = exports.showDestinationProvince = function showDestinationProvince(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintContent: context.formConfig['additional_data.destination_province'].hint,
    expandableHintIsRawHtml: false,
    inputId: 'destinationProvince',
    inputLabel: context.formConfig['additional_data.destination_province'].title,
    inputComponent: _SelectComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.destination_province,
    inputComponentProps: {
      options: getDestinationProvince(context.formConfig['additional_data.destination_province'].options),
      onChangeHook: context.onChangeHook
    }
  });
};

var showStateProvinceOfResidence = exports.showStateProvinceOfResidence = function showStateProvinceOfResidence(context) {
  var data = context.props.fields.application.additional_data;
  var isUSCA = ['CA', 'US'].includes(data.country_of_origin.value);

  return _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'provinceOfResidence',
    inputLabel: context.formConfig['additional_data.province_of_residence']['title' + (isUSCA ? data.country_of_origin.value : '')],
    inputComponent: isUSCA ? _SelectComponent2.default : _TextInputComponent2.default,
    inputComponentField: data.province_of_residence,
    inputComponentProps: {
      options: context.formConfig['additional_data.province_of_residence']['options' + data.country_of_origin.value],
      onChangeHook: context.onChangeHook
    }
  });
};

var showDeductible = exports.showDeductible = function showDeductible(context, maxAge) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    hasExpandableHint: true,
    expandableHintId: 'applicationDeductible',
    expandableHintTitle: context.formConfig['additional_data.deductible'].title,
    expandableHintContent: context.formConfig['additional_data.deductible'].hint,
    inputId: 'deductible',
    inputLabel: context.formConfig['additional_data.deductible'].title,
    inputComponent: _SelectComponent2.default,
    inputComponentField: context.props.fields.application.additional_data.deductible,
    inputComponentProps: {
      options: checkApplicantMaxAge(context, maxAge) ? context.formConfig['additional_data.deductible_oldAge'].options : context.formConfig['additional_data.deductible'].options,
      onChangeHook: context.onChangeHook
    }
  });
};

var getBaseFields = exports.getBaseFields = function getBaseFields() {
  return ['application.quote.email_to', 'application.quote.email_cc', 'applicant[].dob', 'applicant[].additional_data.school', 'applicant[].additional_data.relationship_to_primary_applicant', 'applicant[].additional_data.student_number', 'application.effective_date', 'application.expiry_date', 'application.created_at', 'application.additional_data.quote_reference_id', 'application.additional_data.additional_applicants_number', 'application.additional_data.eligibility', 'application.additional_data.coverage_length', 'application.additional_data.school', 'payment.payment_option'];
};

var getApplicantDetailFields = exports.getApplicantDetailFields = function getApplicantDetailFields() {
  return ['applicant[].first_name', 'applicant[].last_name', 'applicant[].email'];
};

function hideModal(context) {
  context.setState({ showModal: false });
}

function generateContent(hintContent) {
  return hintContent.replace(/class=['"][\w- ]+['"]/g, '');
}

function getSchoolCode(formValues, formConfig) {
  var i = void 0;
  for (i = 0; i < formConfig['additional_data.school_board'].options.length; i++) {
    if (formValues.application.additional_data.school === formConfig['additional_data.school_board'].options[i].value) {
      return formConfig['additional_data.school_board'].options[i].code;
    }
  }
  return 'other';
}

function getTrackingPartner(context) {
  var partners = { slf: ['slf-cdha', 'slf-randstad', 'slf-cihip'], scr: ['cdha', 'ppao', 'randstad'], ohla: ['ohla', 'ohlainsurance'] };
  var trackingCode = context.props.trackingCode.toLowerCase();

  for (var k in partners) {
    if (partners[k].indexOf(trackingCode) > -1) {
      return k;
    }
  }
  return null;
}

var showModal = exports.showModal = function showModal(context) {
  return !context.props.fields.application.expiry_date.value && getTrackingPartner(context) && _react2.default.createElement(
    _reactBootstrap.Modal,
    { show: context.state.showModal },
    _react2.default.createElement(
      'div',
      { className: 'modal-button' },
      _react2.default.createElement('div', {
        dangerouslySetInnerHTML: {
          __html: generateContent(context.formConfig['modal_text_' + getTrackingPartner(context)].text)
        }
      }),
      _react2.default.createElement(
        'div',
        { className: '' },
        _react2.default.createElement(
          'button',
          { className: 'btn btn-primary button margin-left', onClick: hideModal.bind(context, context) },
          (0, _translate.t)('Proceed')
        )
      )
    )
  );
};

var filterList = exports.filterList = function filterList(list, removals) {
  return list.options.filter(function (x) {
    return !removals.some(function (y) {
      return y === x.value;
    });
  });
};

function getCountryStatesProvinces() {
  return {
    CA: ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'],
    US: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY']
  };
}

function transformApplication(formValues) {
  return {
    additional_data: _extends({}, formValues.application.additional_data, {
      affiliate_code: (0, _url2.default)('affiliate_code', null),
      tracking_code: (0, _url2.default)('tracking_code', null),
      sales_channel: (0, _url2.default)('sales_channel', null),
      user_code: (0, _url2.default)('user_code', null),
      renewal_id: (0, _url2.default)('renewal_id', null),
      additional_applicants_number: formValues.applicant.length - 1,
      applicants: formValues.applicant
    }),
    effective_date: formValues.application.effective_date
  };
}

function setValueFromParam(param, paramValue, value, defaultValue) {
  return (0, _url2.default)(param, null) === paramValue ? value : defaultValue;
}


//////////////////
// WEBPACK FOOTER
// ./src/v2/helpers/commonFunctions.js
// module id = 11
// module chunks = 0